import React from "react";

interface CrossKindWarningBarProps {
  fromKindLabel: string;
  toKindLabel: string;
}

/**
 * Inline warning bar rendered when the staged unit's quantity kind differs
 * from the column's current assignment. Apply button text becomes "Confirm"
 * — see UnitPickerFooter for that wiring.
 */
export function CrossKindWarningBar({
  fromKindLabel,
  toKindLabel,
}: CrossKindWarningBarProps) {
  return (
    <div
      role="status"
      style={{
        background: "var(--color-warning-bg)",
        border: "var(--size-border-hairline) solid var(--color-warning)",
        borderRadius: "var(--radius-app)",
        padding: "var(--spacing-sm) var(--spacing-md)",
        fontSize: "var(--font-size-small)",
        color: "var(--color-warning)",
        lineHeight: 1.4,
      }}
    >
      <strong style={{ fontWeight: 500 }}>Changing quantity kind.</strong>{" "}
      You&apos;ll switch this column from <strong>{fromKindLabel}</strong> to{" "}
      <strong>{toKindLabel}</strong>.
    </div>
  );
}
